// Smartsetup Application Configuration
//======================================================================================//
// Application Basic Info
export const appName = "Project setup";

//======================================================================================//
// Application API URLs UAT
// export const appBaseUrl = "https://uatpreventtb237.imonitorplus.com/";
// export const appApiUrl = "https://uatpreventtb237.imonitorplus.com/service/api/";

// Application API URLs LIVE
export const appBaseUrl = "https://ltbigen.duredemos.com/";
export const appApiUrl = "https://ltbigen.duredemos.com/service/api/";

// Application API URLs Local
// export const appBaseUrl = "http://localhost:8080/";
// export const appApiUrl = "http://localhost:8080/dhis/api/";
//======================================================================================//

